import axios from "../../axios";
import {requests} from "../../constants/config";

export const FETCH_TIENDAS = 'FETCH_TIENDAS';
export const FETCH_TIENDAS_SUCCESS = 'FETCH_TIENDAS_SUCCESS';
export const FETCH_TIENDAS_ERROR = 'FETCH_TIENDAS_ERROR';

export const fetchTiendasRequest = () => {
    return {
        type: FETCH_TIENDAS
    }
};

export const fetchTiendasSuccess = (data) => {
    return {
        type: FETCH_TIENDAS_SUCCESS,
        payload: data
    }
};

export const fetchTiendasError = (error) => {
    return {
        type: FETCH_TIENDAS_ERROR,
        payload: error
    }
};

export const getTiendas = () => {
    return (dispatch) => {
        dispatch(fetchTiendasRequest());
        return axios.get(requests.fetchTiendas)
            .then((res) => {
                dispatch(fetchTiendasSuccess(res.data));
            })
            .catch((err) => {
                console.log(err);
                dispatch(fetchTiendasError('No se pudieron cargar las tiendas.'));
            });
    }
};

export default getTiendas;